export default "__VITE_ASSET__d98bba7b__"